import { notifications } from '@mantine/notifications';
import classes from "../style/error.module.css"

const errorNotification = ({ title = "Error", message, color = "red" }) => {
  return notifications.show({
    title,
    message,
    color,
    classNames: classes
  })
}


const successNotification = ({ title = "Success", message, color = "green" }) => {
  return notifications.show({
    title,
    message,
    color,
    classNames: classes
  })
}



const loadingNotification = ({ title = "Loading...", message, color = "green", loading = true }) => {
  return notifications.show({
    title,
    message,
    color,
    // classNames:classes,
    loading,
    autoClose: false,

  })
}

export { errorNotification, successNotification, loadingNotification }
